import {
    Injectable
} from '@angular/core';

import {
    HttpClient
} from '@angular/common/http';

import {
    Observable
} from 'rxjs';
import { ContactFormRequest, CorporateProposalRequest, WebsiteEnquiryResponse } from 'src/app/core/CorporateProposalRequest';
import { ApiConfig } from 'src/app/core/api-config';
 


@Injectable({
    providedIn: 'root'
})
export class WebsiteEnquiryService {

    private readonly apiUrl =
         `${ApiConfig.baseUrl}/WebsiteEnquiry`;


    constructor(
        private http: HttpClient
    ) { }


    // Submit Corporate Training Proposal
    submitCorporateProposal(
        request: CorporateProposalRequest
    ): Observable<WebsiteEnquiryResponse> {

        return this.http.post<WebsiteEnquiryResponse>(
            `${this.apiUrl}/corporate-proposal`,
            request
        );
    }


    // Submit Contact Form
    submitContactForm(
        request: ContactFormRequest
    ): Observable<WebsiteEnquiryResponse> {

        return this.http.post<WebsiteEnquiryResponse>(
            `${this.apiUrl}/contact`,
            request
        );
    }

}